import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × DIOR: Couture precision — structured emotion
// Bar-jacket curves, symmetrical layers, pastel geometry
export function VasarelyDiorMode({ brand }: ModeRendererProps) {
  const pastelPink = "#FFB6C1";
  const pastelGray = "#D3D3D3";

  return (
    <g>
      {/* Elegant pastel background */}
      <defs>
        <linearGradient id="dior-elegance" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F8F8F8" />
          <stop offset="100%" stopColor="#E8E8E8" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#dior-elegance)" />

      <g transform="translate(397 540)">
        {/* Bar-jacket curves (New Look silhouette) */}
        {Array.from({ length: 8 }).map((_, i) => {
          const y = -200 + i * 50;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -280 + j * 14;
            const curve = Math.sin(j * 0.2) * 40;
            return `${x},${y + curve}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={i % 2 === 0 ? pastelPink : pastelGray}
              strokeWidth="3"
              opacity="0.5"
            />
          );
        })}

        {/* Symmetrical couture layers */}
        {[-1, 1].map((dir) =>
          Array.from({ length: 6 }).map((_, i) => {
            const x = dir * (80 + i * 30);
            const y = -140 + i * 45;
            return (
              <ellipse
                key={`${dir}-${i}`}
                cx={x}
                cy={y}
                rx="50"
                ry="70"
                fill={pastelPink}
                opacity="0.2"
              />
            );
          })
        )}

        {/* Pastel geometric grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 48;
            const y = (j - 7.5) * 44;
            const precision = Math.sin(i * 0.5) * Math.cos(j * 0.4) * 8;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 18 + precision}
                y={y - 18}
                width="36"
                height="36"
                fill={pastelGray}
                opacity="0.15"
              />
            );
          })
        )}

        {/* Structured emotion circles */}
        {Array.from({ length: 14 }).map((_, i) => {
          const r = 50 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? pastelPink : pastelGray}
              strokeWidth="2"
              opacity={0.3 - i * 0.015}
            />
          );
        })}

        {/* Couture precision nodes */}
        {[0, 72, 144, 216, 288].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="12"
                fill={pastelPink}
                opacity="0.6"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="18"
                fill="none"
                stroke={pastelPink}
                strokeWidth="2"
                opacity="0.4"
              />
            </g>
          );
        })}

        {/* Central elegance */}
        <rect x="-60" y="-100" width="120" height="200" fill={pastelPink} opacity="0.2" rx="10" />
        <rect x="-50" y="-90" width="100" height="180" fill="none" stroke={pastelGray} strokeWidth="2" opacity="0.5" rx="8" />
      </g>

      {/* Dior inscription */}
      <text x="397" y="1000" textAnchor="middle" fontFamily="serif" fontSize="11" fill="#888" opacity="0.6" fontStyle="italic">
        couture précision
      </text>
    </g>
  );
}
